module.exports = __webpack_public_path__ + "static/staff-7-428c5555127efdb2f7696b13c06a45b8.png";